import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogArticle from './pages/BlogArticle';
import RechercheService from './pages/services/RechercheService';
import VendreMonBateau from './pages/VendreMonBateau';
import MentionsLegales from './pages/MentionsLegales';
import VieABord from './pages/VieABord';
import Admin from './pages/Admin';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import PolitiqueCookies from './pages/PolitiqueCookies';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import ExercerDroitsRGPD from './pages/ExercerDroitsRGPD';
import AnalyseAnnonce from './pages/AnalyseAnnonce';
import MethodeValidatedBoat from './pages/MethodeValidatedBoat';
import TransmettreSonBateau from './pages/TransmettreSonBateau';
import SellBoatPopup from './components/SellBoatPopup';
import CookieConsent from './components/CookieConsent';
import ChatWidget from './components/ChatWidget';
import BoatsCatalog from './pages/BoatsCatalog';
import BoatDetail from './pages/BoatDetail';
import BoatsCompare from './pages/BoatsCompare';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/services/recherche-bateau" element={<RechercheService />} />
            <Route path="/vendre-mon-bateau" element={<VendreMonBateau />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/vie-a-bord" element={<VieABord />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/politique-cookies" element={<PolitiqueCookies />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/exercer-mes-droits" element={<ExercerDroitsRGPD />} />
            <Route path="/analyse-annonce-bateau" element={<AnalyseAnnonce />} />
            <Route path="/methode-validatedboat" element={<MethodeValidatedBoat />} />
            <Route path="/transmettre-son-bateau" element={<TransmettreSonBateau />} />
            <Route path="/bateaux-a-vendre" element={<BoatsCatalog />} />
            <Route path="/bateaux-a-vendre/comparer" element={<BoatsCompare />} />
            <Route path="/bateaux-a-vendre/:slug" element={<BoatDetail />} />
          </Routes>
          <SellBoatPopup />
          <CookieConsent />
          <ChatWidget />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;